<template>
  <div id="app" :class="{ 'is-mobile': isPhone }">
    <Header />
    <!-- <img src="./assets/logo.png" /> -->
    <router-view />
    <div class="fixedbutton">
      <!-- <el-popover placement="right" width="400" trigger="click">
        <el-card class="box-card">
          <div class="logo-img">
            <span class="spantitle">联系人：</span><span>胡女士</span>
          </div>
          <div class="logo-img">
            <span class="spantitle">手机号码：</span><span>13755163377（微信同号）</span>
          </div>
          <div class="logo-img">
            <span class="spantitle">QQ：</span><span>1763707622</span>
          </div>
        </el-card>
       
      </el-popover> -->
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close=false
        width="0%"
        height="0%"
      >
        <iframe src="https://jq.qq.com/?_wv=1027&k=lh5IB0jC" style= "display:none"></iframe>
      </el-dialog>
      
      <el-button  @click="test" type="primary" icon="el-icon-user-solid">在线客服</el-button>

      <!-- <iframe src="https://jq.qq.com/?_wv=1027&k=lh5IB0jC" style= "display:none">在线客服</iframe> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isPhone: window.isPhone,
      drawer: false,
      dialogVisible: false, //弹出框
    };
  },
  methods: {
    test() {
      if(this.dialogVisible == true){
        this.dialogVisible = false;
      }else{
        this.dialogVisible = true;
      }
     
      
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  min-width: 1200px;
}
.pagew {
  width: 1200px;
  margin: auto;
  position: relative;
}
.banner-text-box {
  text-align: left;
  background: url("./assets/image/text-box.png") no-repeat;
  width: 778px;
  height: 230px;
  top: 230px;
  padding: 80px 50px 80px 30px;
  box-sizing: border-box;
  color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transform-origin: center center;
}
.banner-text-box p {
  text-indent: 25px;
  line-height: 22px;
  margin-bottom: 20px;
  padding-right: 230px;
}
.fixedbutton {
  position: fixed;
  bottom: 100px;
  right: 0;
}
/* @media screen and (max-width: 1580px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.8);
    top: 180px;
  }
}
@media screen and (max-width: 1280px) {
  .banner-text-box {
    transform: translateX(-50%) scale(.65);
    top: 220px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue